import { Target } from "../../Business/dto/Brief";
import { ExternalDataPicker } from "./ExternalDataPicker";
import { DataKey } from "../../Business/dto/ExternalSystemElement";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export interface TargetPickerProps {
    setSelectedTarget: (sector: Target | undefined) => void;
    required?: boolean;
    value: Target | undefined;
}

export const TargetPicker = (props: TargetPickerProps) => {
    const { t } = useTranslation();
    
    return (
        <>
                <ExternalDataPicker
                    setSelectedData={props.setSelectedTarget}
                    placeholder={t("txt_target")}
                    displayCode={false}
                    dataKey={DataKey.Target}
                    icon={faUser}
                    controlId="targetPicker"
                    required={props.required}
                    value={props.value ? [props.value] : []}
                />
        </>
    )
};